var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkboxtags"},[_c('el-checkbox-group',{on:{"change":_vm.handleChange},model:{value:(_vm.arr),callback:function ($$v) {_vm.arr=$$v},expression:"arr"}},_vm._l((_vm.checkboxGroup),function(x,index){return _c('el-checkbox',{key:index,attrs:{"label":x.value,"checked":_vm.getChecked(x),"border":""}},[_vm._v(_vm._s(x.label))])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e71a7078","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/packages/checkboxtags/CheckboxTags.vue
// module id = 33
// module chunks = 0